<template>
<div class="content-text-container">
    <div class="conten-section">
        <p>Welcome to Charm-Vibe . By using our website (https://www.charm-vibe.com) and services, you agree to comply with and be bound by the following terms.</p>
    </div>
    <div class="conten-section">
        <h3>1. Eligibility</h3>
        <p>You must be at least 18 years old to use our platform. By creating an account, you confirm that you meet this age requirement.</p>
    </div>
    <div class="conten-section">
        <h3>2. Services Offered</h3>
        <p>Charm-Vibe connects users with verified cosmetic practitioners for consultations, procedures, and content. We do not provide medical services directly and are not liable for any procedure outcomes.</p>
    </div>
    <div class="conten-section">
        <h3>3. User Responsibilities</h3>
        <p>- Provide accurate personal information during sign-up.</p>
        <p>- Use the platform for lawful and ethical purposes only.</p>
        <p>- Do not impersonate, misrepresent, or misuse the platform or upload unauthorized third-party images.</p>
    </div>
    <div class="conten-section">
        <h3>4. Consultations and Payments</h3>
        <p>Charm-Vibe facilitates online consultations and procedure bookings. All payments are handled via our secure gateway. Refunds and cancellations are subject to provider terms.</p>
    </div>
    <div class="conten-section">
        <h3>5. Content Ownership</h3>
        <p>Users retain rights to their uploaded content but grant us a license to use it for internal purposes (e.g., consultation, moderation). No public sharing without written consent.</p>
    </div>
    <div class="conten-section">
        <h3>6. Account Termination</h3>
        <p>We reserve the right to suspend or terminate accounts that breach these terms or engage in harmful activity.</p>
    </div>
    <div class="conten-section">
        <h3>7. Limitation of Liability</h3>
        <p>Charm-Vibe is not responsible for interactions between users and providers. Always consult with a licensed practitioner before undergoing any procedure.</p>
    </div>
    <div class="conten-section">
        <h3>8. Changes to Terms</h3>
        <p>We may update these Terms at any time. Continued use of the site constitutes acceptance of those changes.</p>
    </div>
</div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.content-text-container{
    .conten-section{
        h3{
            color: #000000;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; 
        }
        p{
            color: #000000;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; 
            word-wrap: break-word;
        }

        .sub-item{
            text-indent: 12px;
        }
    }
}
</style>
